export default __webpack_public_path__ + "880d39a08e5397b931480d5e4b5e73b3.png";